import { SimData } from 'common/components/Sim/constants/sim.ts';
import { useQuery } from '@tanstack/react-query';
import { getAvailableActionsForSims } from 'products/sim/Actions/api/simActionsApi.ts';
import { simProductsQueries } from 'products/sim/Inventory/queries/simProductsQueries.ts';
import { useMemo } from 'react';
import { useIsSimInLifeChangesAvailable } from 'products/sim/Actions/hooks/useIsSimInLifeChangesAvailable.ts';

export const useExtendsSimProductsWithActionsAvailability = (simProducts: SimData[]) => {
  const inlifeChangesEnabled = useIsSimInLifeChangesAvailable();
  const iccids = simProducts.map((sim) => sim.iccid);

  const { data: availableSimActions } = useQuery({
    queryKey: simProductsQueries.availableActions({ iccids }),
    queryFn: () => getAvailableActionsForSims({ iccids }),
    enabled: inlifeChangesEnabled,
  });

  return useMemo(() => {
    return simProducts.map((simProduct) => ({
      ...simProduct,
      availableActions: new Set(availableSimActions?.[simProduct.iccid] ?? []),
    }));
  }, [simProducts, availableSimActions]);
};
